<div class="dialogContainer" [ngClass]="{ 'visible' : showModal }">
  <div class="dialog">
    @if (form != null) {
      <div class="grid-container">
        <div class="grid-x" [formGroup]="form">
          <div class="cell large-9 medium-9 small-9 bold text-align-left">
            <h3>Edit Formation Record</h3>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <span class="minor-margin-right">
              <button class="button" (click)="save()" [disabled]="form?.invalid">Save</button>
            </span>
            <span>
              <button class="button" (click)="close()">Close</button>
            </span>
          </div>
          <div class="cell large-6 medium-6 small-6 text-align-right padding-right">
            @if (form?.get('formation')?.invalid && form?.get('formation')?.touched) {
              <span class="bold red">
                Formation is invalid
              </span>
            }
            <label for="formationSelector">Formation:</label>
          </div>
          <div class="cell large-6 medium-6 small-6 padding-left">
            <ng-select id="formationSelector" formControlName="formation" [multiple]="false" [items]="formationTypes" bindLabel="definition" bindValue="code" (ngModelChange)="formationChanged($event)"></ng-select>
          </div>
          <div class="cell large-3 medium-3 small-3 text-align-right padding-right">
            <label for="top">Top:</label>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <input type="number" formControlName="top" min="0" />
          </div>
          <div class="cell large-3 medium-3 small-3 text-align-right padding-right">
            <label for="bottom">Bottom:</label>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <input type="number" formControlName="bottom" min="0" />
          </div>
          <div class="cell large-6 medium-6 small-6 text-align-center">
            <div class="checkbox">
              <input class="show-for-sr" id="producingFormation" type="checkbox" formControlName="producingFormation" />
              <label for="producingFormation">
                Producing Formation: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>
            </div>
          </div>
          <div class="cell large-3 medium-3 small-3 text-align-right padding-right">
            <label for="methodObtained">Method Obtained:</label>
          </div>
          <div class="cell large-3 medium-3 small-3">
            <select id="methodObtained" formControlName="methodObtained">
              @for (method of methods; track method) {
                <option [value]="method.Code">{{method.Definition}}</option>
              }
            </select>
          </div>
          <div class="cell large-3 medium-3 small-3 text-align-right">
            <label for="showsOf">Shows Of Oil/Gas/Brine or Fresh Water:</label>
          </div>
          <div class="cell large-9 medium-9 small-9 padding-left">
            <input type="text" formControlName="showsOf" />
          </div>
          <div class="cell large-3 medium-3 small-3 text-align-right">
            <label for="remarks">Remarks:</label>
          </div>
          <div class="cell large-9 medium-9 small-9 padding-left">
            <textarea formControlName="remarks"></textarea>
          </div>
          <div class="cell large-3 medium-3 small-3 text-align-right">
            @if (form?.get('comments')?.invalid && form?.get('comments')?.touched) {
              <span class="bold red">
                Comments is invalid
              </span>
            }
            <label for="comments">Comments:</label>
          </div>
          <div class="cell large-9 medium-9 small-9 padding-left text-align-left">
            <div id="comments" formControlName="comments" [froalaEditor]="froalaOptions"></div>
          </div>
        </div>
      </div>
    }
  </div>
</div>


